import { Alert, Button, Popconfirm, Space } from "antd";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { deletePromotion, getPromotions } from "../../store/slices/promotionSlice";
import { CheckCircleOutlined, CloseCircleOutlined, DeleteFilled, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Can from "../../permission/Can";

const PromotionList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showPopconfirm = (id) => {
        setOpen(id);
    };

    const handleDeletePromotion = async (id) => {
        try {
            setConfirmLoading(true);

            const resultAction = await dispatch(deletePromotion(id));

            if (deletePromotion.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || "Deleted");
                setAlertType("success");
                setReload(!reload);
                setOpen(null);
            } else {
                setAlertMessage(resultAction?.payload?.message);
                setAlertType("error");
            }
        } catch (error) {
            console.log(error?.response?.data)
            setAlertMessage("Error deleting promotion");
            setAlertType("error");
        } finally {
            setConfirmLoading(false);
            setTimeout(() => setAlertMessage(""), 4000);
        }
    };

    const handleCancel = () => {
        setOpen(null);
    };

    const columns = [
        {
            title: "Day",
            dataIndex: "day",
            key: "day",
        },
        {
            title: "Discount (%)",
            dataIndex: "discount_percent",
            key: "discount_percent",
            render: (value) => `${value}%`
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            render: (value) => (
                <span style={{ color: value ? "green" : "red" }}>
                    {value ? "Active" : "Inactive"}
                </span>
            )
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (_, data) => {
                const date = new Date(data?.createdAt);
                return date.toDateString();
            }
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, data) => (
                <Space>
                    <Can permission="edit_promotion">
                        <Button
                            onClick={() => navigate('/promotion/edit/' + data?._id)}
                            icon={<EditOutlined />}
                            size="small"
                        >
                            Edit
                        </Button>
                    </Can>

                    <Can permission="delete_promotion">
                        <Popconfirm
                            title="Delete confirmation"
                            description="Do you want to delete this promotion?"
                            open={open === data?._id}
                            icon={<DeleteFilled />}
                            onConfirm={() => handleDeletePromotion(data?._id)}
                            okButtonProps={{ loading: confirmLoading }}
                            onCancel={handleCancel}
                        >
                            <Button
                                icon={<DeleteOutlined />}
                                onClick={() => showPopconfirm(data?._id)}
                                size="small"
                                danger
                            >
                                Delete
                            </Button>
                        </Popconfirm>
                    </Can>

                </Space>
            ),
        },
    ];

    return (
        <div>
            {alertMessage && (
                <Alert
                    message={alertMessage}
                    type={alertType}
                    showIcon
                    icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    closable
                    onClose={() => setAlertMessage('')}
                    style={{
                        marginBottom: 24,
                        borderRadius: '8px',
                    }}
                />
            )}
            <div style={{
                marginBottom: 16,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <h1>Promotions</h1>
                <Can permission="promotion_create">
                    <Button type="primary" onClick={() => navigate('/coupon/add')}>
                        Add Coupon
                    </Button>
                </Can>
            </div>

            <TableComponent
                listData={getPromotions}
                columns={columns}
                reload={reload}
                placeholder="Search promotions..."
            />
        </div>
    );
};

export default PromotionList;